import { h } from 'preact';
import React, { useEffect, useRef } from 'react';

import { ButtonSettings } from './ButtonSettings';
import { makeText, languageUsed, isActionAllowed } from '../../util';
import { useDev } from '../../hooks';

import './Button.css';

export const Button = ({
  component,
  makeChoice,
  dev,
  path,
  language,
  className,
  shown,
  neutralPm,
  allSelectionsMade
}) => {
  const settings = new ButtonSettings(component.settings);
  const { devActions, devClass, pathString } = useDev(path, dev);

  const prevShown = useRef()

  useEffect(() => {
    const { startFocus } = settings;
    if (startFocus) {
      SpatialNavigation.clear();
      SpatialNavigation.add({
        selector: '.start-focus',
        defaultElement: '.start-focus',
      })
      setTimeout(() => SpatialNavigation.focus(), 50)
    }
  }, [shown])

  useEffect(() => {
    prevShown.current = shown
  })

  const disable = !dev && neutralPm && settings.choice_option && settings.choice_option.type === 'SE' && !allSelectionsMade;

  const styles = {
    opacity: disable ? .5 : 1,
    ...settings.padding,
    ...settings.margin,
    ...settings.border,
    ...settings.font
  };

  /* WIDTH & HEIGHT */
  const { paddingLeft, paddingRight } = settings.padding;
  const { marginLeft, marginRight } = settings.margin;

  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  if (settings.width.type === '%') {
    styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`;
  };

  styles.background = settings.background;

  const callMakeChoice = () => {
    const choice = component.settings.choice_option.data;
    const choiceType = component.settings.choice_option.type;
    if (choice.button_text) {
      makeChoice(choice.button_text, languageUsed(language, settings, 'text'), choiceType === 'SE', choice);
    };
  };

  const getChoiceOptionClass = () => {
    const choiceOption = component.settings.choice_option;
    const type = choiceOption ? choiceOption.type : null;
    return type ? `sp_choice_type_${type}` : '';
  }

  let btnClassName = 'message-component message-button no-children focusable' + className + devClass + (settings.startFocus ? ' start-focus' : '');
  btnClassName += ' ' + getChoiceOptionClass();

  const btnText = makeText(dev, settings, 'text', language);

  return (
    <button
      aria-disabled={disable}
      disabled={disable}
      title={btnText}
      aria-label={btnText}
      onClick={callMakeChoice}
      onKeyDown={(e) => isActionAllowed(e.key) && callMakeChoice()}
      className={btnClassName}
      path={dev ? pathString : null}
      style={styles}
      {...devActions}
    >
      {btnText}
    </button>
  );
}